module.exports = __webpack_public_path__ + "static/media/Events__addButton.f2e84721.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Events__addButton.svg
// module id = 1106
// module chunks = 0